var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 29,
  height: 10,
  viewBox: "0 0 29 10",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.5 5L4.875 0.5L5.695 1.28789L2.578 4.43737L28.5 4.43737V5.56263L2.578 5.56263L5.641 8.71211L4.875 9.5L0.5 5Z",
  fill: "black"
})));
export default SvgIconArrow;